import { css } from '../lib/css'
import { Hover } from '../lib/Hover'
import { SOCIALS } from '../lib/socials'

/**
 * Footer social icons. Renders only the platforms that have a URL set in
 * src/lib/socials.ts, so unconfigured accounts never ship as dead links.
 */
export default function Socials() {
  const active = SOCIALS.filter((s) => s.url)
  if (!active.length) return null
  return (
    <div style={css(`display: flex; gap: 18px; margin-top: 10px`)}>
      {active.map((s) => (
        <Hover
          key={s.name}
          as="a"
          href={s.url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={s.name}
          style={css(`display: inline-flex; color: #93aeb8`)}
          hoverStyle={css(`color: #7fd4c4`)}
        >
          <svg width="26" height="26" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d={s.path} />
          </svg>
        </Hover>
      ))}
    </div>
  )
}
